import axiosClient, {
  TOKEN_STORAGE_KEY,
  getApiErrorMessage,
  getApiValidationErrors,
} from './axiosClient';

import createFormData from './formData';

import analyticsApi from './analyticsApi';
import aiMenuDesignApi from './aiMenuDesignApi';
import categoriesApi from './categoriesApi';
import establishmentsApi from './establishmentsApi';
import menusApi from './menusApi';
import menuTemplatesApi from './menuTemplatesApi';
import ordersApi from './ordersApi';
import productsApi from './productsApi';
import publicMenuApi from './publicMenuApi';
import authApi from './authApi';
import waiterOrdersApi from './waiterOrdersApi';

export {
  axiosClient,
  TOKEN_STORAGE_KEY,
  getApiErrorMessage,
  getApiValidationErrors,
  createFormData,
  analyticsApi,
  aiMenuDesignApi,
  categoriesApi,
  establishmentsApi,
  menusApi,
  menuTemplatesApi,
  ordersApi,
  productsApi,
  publicMenuApi,
  authApi,
  waiterOrdersApi,
};

const api = {
  axiosClient,
  TOKEN_STORAGE_KEY,
  getApiErrorMessage,
  getApiValidationErrors,
  createFormData,
  analyticsApi,
  aiMenuDesignApi,
  categoriesApi,
  establishmentsApi,
  menusApi,
  menuTemplatesApi,
  ordersApi,
  productsApi,
  publicMenuApi,
  authApi,
  waiterOrdersApi,
};

export default api;